import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import ChatBox from './components/feature/ChatBox';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <ChatBox />
    </BrowserRouter>
  );
}

export default App;
